import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        wrapper: {
            display: 'flex',
            width: '300px',
            gap: theme.spacing(3),
            alignItems: 'center',
            margin: theme.spacing(-1, 1.25, 0, 1.25),
        },
        inputWrapper: {
            display: 'flex',
            flexDirection: 'column',
            margin: 0,
        },
        label: {
            color: `${theme.palette.secondary[700]} !important`,
            fontSize: `${theme.typography.caption.fontSize}px !important`,
            lineHeight: '1.15 !important',
            whiteSpace: 'nowrap',
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minWidth: 0,
        },
    }
})

export default useStyles
